import { Box, Circle, Text } from "@chakra-ui/react";
import { ReactComponent as Quiz } from "../../svg/puzzle-piece.svg";
import { ReactComponent as Assessments } from "../../svg/assessments.svg";
import { ReactComponent as Certificates } from "../../svg/certificate.svg";
import { ReactComponent as ScorePoints } from "../../svg/scorepoints.svg";

export default function Statistics({statisticsData,isLoading}) {


  return (
    <Box w="100%" d="flex" flexDir="column" mb="1.5rem">
      <Text
        fontSize="15px"
        color="#222222"
        fontWeight="800"
        style={{ fontFamily: "Mulish, sans-serif" }}
        mb="1rem"
      >
        OVERALL STATISTICS
      </Text>
      
      <Box w="100%" d={{ base: '', md: 'flex', lg: 'flex' }}  justifyContent="space-between">
        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#E5F7FF"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <ScorePoints />
          </Circle>
          <Text color="#4682AF" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Teachers Registered
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_tutor_registered
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#F0E9FF"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
          <ScorePoints />
            {/* <CoursesEnrolled /> */}
          </Circle>
          <Text color="#7958C9" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Students Registered
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_student_registered
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#F8F3D6"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <Quiz stroke="#967132" fill="#967132" width="20px" height="20px" />
          </Circle>
          <Text color="#967132" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Class Schedules
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_departments
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#DEEFE7"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <Assessments />
          </Circle>
          <Text color="#26CE83" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Live Session
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_live_sessions
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
         w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#FFEBE9"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <Certificates width="20px" height="20px" fill="#FA5B59" />
          </Circle>
          <Text color="#FA5B59" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Assessments Held
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_assessments
            }
          </Text>
        </Box>
      </Box>
      <Box
        w="100%"
        d={{ base: '', md: 'flex', lg: 'flex' }}
        justifyContent="space-between"
        style={{ marginTop: 40 }}
      >
        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#E5F7FF"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <ScorePoints />
          </Circle>
          <Text color="#4682AF" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Holidays
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_holidays
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#F0E9FF"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
          <ScorePoints />
            {/* <CoursesEnrolled /> */}
          </Circle>
          <Text color="#7958C9" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Subjects
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_subjects
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#F8F3D6"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <Quiz stroke="#967132" fill="#967132" width="20px" height="20px" />
          </Circle>
          <Text color="#967132" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Library Items
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_library_items
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#DEEFE7"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <Assessments />
          </Circle>
          <Text color="#26CE83" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Exam Answers
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_exam_answers
            }
          </Text>
        </Box>

        <Box
          borderRadius="10px"
          w={{ base: '93%', md: '18%', lg: '18%' }}
          style={{ fontFamily: "Mulish, sans-serif" }}
          bg="#FFEBE9"
          py="1.5rem"
          pl="1rem"
          mb="1.5rem"
        >
          <Circle size="50px" bg="#ffffff" mb="0.5rem">
            <Certificates width="20px" height="20px" fill="#FA5B59" />
          </Circle>
          <Text color="#FA5B59" fontSize="15px" fontWeight="700" mb="0.5rem">
            No. of Announcements
          </Text>
          <Text fontSize="20px" fontWeight="800" color="#222222">
            {
              statisticsData.no_of_notifications
            }
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
